import api from './api';

const walletService = {
  // Get wallet details and balance
  getWallet: () => api.get('/wallet'),
  
  // Get wallet summary (for header)
  getSummary: () => api.get('/wallet/summary'),
  
  // Get transaction history
  getTransactions: (limit = 50, type = null) => {
    const params = { limit };
    if (type) params.type = type;
    return api.get('/wallet/transactions', { params });
  },
  
  // Get usage history
  getUsages: (limit = 50, featureType = null) => {
    const params = { limit };
    if (featureType) params.feature_type = featureType;
    return api.get('/wallet/usages', { params });
  },
  
  // Get pricing information
  getPricing: () => api.get('/wallet/pricing'),
};

export default walletService;
